<template>
  <!-- 送货调度 多票派车 -->
  <div class="contentBox">
    <div style="height: 60px; width: 100%"></div>
    <div class="topBtns">
      <el-button style="margin-top: 10px" class="glo_bgcMainColor" @click="submit('SAVE')">保存</el-button>
      <!-- v-if="outgoingId"  -->
      <el-button style="margin-top: 10px" class="glo_bg" @click="submit('DISPATCH')">调度确认</el-button>
    </div>
    <!-- 基本信息 -->
    <div class="infoDiv">
      <div class="h3title">基本信息</div>
      <div class="formbox">
        <el-form label-width="120px" class="glo_formBox">
          <el-form-item label="配载批次:">
            <el-input disabled placeholder="自动生成"></el-input>
          </el-form-item>
          <el-form-item class="dialogTims" label="预计发车日期:" required>
            <el-date-picker v-model="dialogFormDispatch.planDepartureTime" class="input" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="送货计划:">
            <el-select filterable clearable v-model="dialogFormDispatch.startAddrType" placeholder="请选择">
              <el-option v-for="(item, index) in startAddrTypeList" :key="index" :label="item.name" :value="item.val"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="始发网点:" :required="dialogFormDispatch.startAddrType == 1">
            <el-select v-model="dialogFormDispatch.startDeptId" placeholder="请选择" clearable>
              <el-option v-for="item in storageList" :key="item.documentId" :label="item.name" :value="item.documentId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车型:">
            <el-select filterable clearable v-model="dialogFormDispatch.carTypeConfDictId" placeholder="请选择">
              <el-option v-for="(item, index) in car_type_list" :key="index" :label="item.key" :value="item.confDictId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车辆分类:">
            <el-select filterable clearable v-model="dialogFormDispatch.carCategoryConfDictId" placeholder="请选择" @change="changecarCategoryConfDictId">
              <el-option v-for="(item, index) in car_categoryList" :key="index" :label="item.key" :value="item.confDictId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item required label="车牌号码:">
            <el-select filterable clearable allow-create remote v-model="dialogFormDispatch.carNumber" placeholder="请选择">
              <el-option v-for="(item, index) in carNumberList1" :key="index" :label="item.carNumber" :value="item.carNumber"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否牵引车:">
            <el-select filterable clearable v-model="dialogFormDispatch.isTractor" placeholder="请选择">
              <el-option v-for="(item, index) in isTractorList" :key="index" :label="item.name" :value="item.val"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="挂车号码:">
            <el-select v-model="dialogFormDispatch.trailerNumber" :remote-method="(e) => getcarNumberRmethod(e)" filterable clearable allow-create remote placeholder="请选择">
              <el-option v-for="(item, index) in carNumberList2" :key="index" :label="item.carNumber" :value="item.carNumber"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item required label="司机一:">
            <el-select
              filterable
              clearable
              v-model="dialogFormDispatch.driverOneName"
              placeholder="请选择"
              allow-create
              remote
              :remote-method="
                (val) => runPageReport_down_list_driver('driverList1', val)
              "
              @focus="runPageReport_down_list_driver('driverList1')"
              @change="
                changeDrivers(
                  $event,
                  'driverOneId',
                  'driverOneName',
                  'driverList1',
                  'driverOnePhone',
                  'driverOneIdcard'
                )
              "
            >
              <el-option v-for="(item, index) in driverList1" :key="index" :label="item.name" :value="item.name"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item required label="司机一电话:">
            <el-input v-model="dialogFormDispatch.driverOnePhone" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item required label="司机一身份证:">
            <el-input v-model="dialogFormDispatch.driverOneIdcard" placeholder="请输入"></el-input>
          </el-form-item>
          <el-checkbox v-model="dialogFormDispatch.isAddDriverOne">收录司机</el-checkbox>
          <el-form-item label="司机二:">
            <el-select
              filterable
              clearable
              v-model="dialogFormDispatch.driverTwoName"
              placeholder="请选择"
              allow-create
              remote
              :remote-method="
                (val) => runPageReport_down_list_driver('driverList2', val)
              "
              @focus="runPageReport_down_list_driver('driverList2')"
              @change="
                changeDrivers(
                  $event,
                  'driverTwoId',
                  'driverTwoName',
                  'driverList2',
                  'driverTwoPhone',
                  'driverTwoIdcard'
                )
              "
            >
              <el-option v-for="(item, index) in driverList2" :key="index" :label="item.name" :value="item.name"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="司机二电话:">
            <el-input v-model="dialogFormDispatch.driverTwoPhone" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="司机二身份证:">
            <el-input v-model="dialogFormDispatch.driverTwoIdcard" placeholder="请输入"></el-input>
          </el-form-item>
          <el-checkbox v-model="dialogFormDispatch.isAddDriverTwo">收录司机</el-checkbox>
          <el-form-item label="押运员一:">
            <el-select
              v-model="dialogFormDispatch.supercargoOneName"
              placeholder="请选择"
              filterable
              clearable
              allow-create
              remote
              :remote-method="
                (val) => runPageReport_down_list_driver('driverList3', val)
              "
              @focus="runPageReport_down_list_driver('driverList3')"
              @change="
                changeDrivers(
                  $event,
                  'supercargoOneId',
                  'supercargoOneName',
                  'driverList3'
                )
              "
            >
              <el-option v-for="(item, index) in driverList3" :key="index" :label="item.name" :value="item.name"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="押运员二:">
            <el-select
              v-model="dialogFormDispatch.supercargoTwoName"
              placeholder="请选择"
              filterable
              clearable
              allow-create
              remote
              :remote-method="
                (val) => runPageReport_down_list_driver('driverList4', val)
              "
              @focus="runPageReport_down_list_driver('driverList4')"
              @change="
                changeDrivers(
                  $event,
                  'supercargoTwoId',
                  'supercargoTwoName',
                  'driverList4'
                )
              "
            >
              <el-option v-for="(item, index) in driverList4" :key="index" :label="item.name" :value="item.name"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="随车人员一:">
            <el-select
              v-model="dialogFormDispatch.carFollowPersonnelOneName"
              placeholder="请选择"
              clearable
              remote
              filterable
              :remote-method="
                (e) => {
                  remoteMethod(e, 'employee', 'employeeList');
                }
              "
              @focus="focusMethod('employee', 'employeeList')"
              @clear="remoteMethod('', 'employee', 'employeeList')"
              allow-create
              @change="
                changeSuiChe(
                  $event,
                  'carFollowPersonnelOneId',
                  'carFollowPersonnelOneName'
                )
              "
            >
              <el-option v-for="(item, index) in employeeList" :key="index" :label="item.name" :value="item.name" />
            </el-select>
          </el-form-item>
          <el-form-item label="随车人员二:">
            <el-select
              v-model="dialogFormDispatch.carFollowPersonnelTwoName"
              placeholder="请选择"
              clearable
              remote
              filterable
              :remote-method="
                (e) => {
                  remoteMethod(e, 'employee', 'employeeList2');
                }
              "
              @focus="focusMethod('employee', 'employeeList2')"
              @clear="remoteMethod('', 'employee', 'employeeList2')"
              allow-create
              @change="
                changeSuiChe(
                  $event,
                  'carFollowPersonnelTwoId',
                  'carFollowPersonnelTwoName'
                )
              "
            >
              <el-option v-for="(item, index) in employeeList2" :key="index" :label="item.name" :value="item.name" />
            </el-select>
          </el-form-item>
          <el-form-item label="预计总费用:">
            <el-input v-model="dialogFormDispatch.totalAmount" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="发车合同号:">
            <el-input v-model="dialogFormDispatch.dispatchContractNumber" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="textArea" style="width: 100%" label="备注:">
            <el-input type="textarea" v-model="dialogFormDispatch.remarks"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="glo_Table">
      <el-table
        header-align="center"
        ref="mytable1"
        @row-click="rowclick1"
        :data="tableData1"
        border
        stripe
        :highlight-current-row="true"
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange1"
      >
        <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
        <!-- <el-table-column fixed="left" align="center" type="selection" width="60"></el-table-column> -->
        <el-table-column label="配载顺序" width="200">
          <template slot-scope="scope">
            <el-input v-model="tableData1[scope.$index].sort" placeholder="请输入" filterable></el-input>
          </template>
        </el-table-column>
        <template v-for="(item, index) in myTableHeard1">
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-if="item && item.isShow"
          ></el-table-column>
        </template>
      </el-table>
    </div>

    <!-- 新增修改 -->
    <myDialog :diaWidth="diaWidth1" :dialogTitle="dialogTitle1" :isShowDialog="isShowDialog1" @handleCloseDia="handleCloseDia1" @diaCancelBtn="handleCloseDia1" @diaConfirmBtn="diaConfirmBtn1">
      <div class="formbox" v-if="isShowDialog1">
        <el-form class="glo_formBox" label-width="120px">
          <el-form-item label="姓名:">
            <el-input v-model="dialogForm1.employeeName1" placeholder="请输入"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!-- 弹窗 收件人地址 -->
    <myDialog :diaWidth="diaWidth3" :dialogTitle="dialogTitle3" :isShowDialog="isShowDialog3" @handleCloseDia="handleCloseDia3" @diaCancelBtn="handleCloseDia3" @diaConfirmBtn="diaConfirmBtn3">
      <div class="glo_dialogForm">
        <!-- 查询条件 -->
        <div ref="queryForm">
          <el-form v-if="isShowDialog3" :model="queryData" class="glo_form" label-position="left">
            <el-form-item class="queryItems" label="姓名:">
              <el-input clearable v-model="queryData.name" placeholder="请输入" @keyup.enter.native="getCustomerAddrList()"></el-input>
            </el-form-item>
            <el-button class="glo_btnItems glo_bgcMainColor" @click="getCustomerAddrList">查询</el-button>
          </el-form>
        </div>
        <div class="glo_Table">
          <el-table :height="500" header-align="center" ref="mytable" @row-click="rowclick" :data="tableData" border stripe @selection-change="handleSelectionChange">
            <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
            <el-table-column fixed="left" align="center" type="selection" width="60"></el-table-column>
            <template v-for="(item, index) in addressTableHeard">
              <el-table-column
                :key="index"
                :label="item.name"
                :prop="item.field"
                align="center"
                sortable
                :show-overflow-tooltip="true"
                :min-width="item.width"
                :data-isTotal="item.isTotal"
                v-if="item && item.isShow"
              ></el-table-column>
            </template>
          </el-table>
        </div>
        <!-- 分页 -->
        <paging ref="pags" :pageNum="pageStart" :total="pageCount" :size="pageTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"></paging>
      </div>
    </myDialog>
  </div>
</template>
<script>
import myDialog from "@/components/Dialog.vue";
import paging from "@/components/pagings.vue"; //分页组件
export default {
  inject: ["reload"],
  components: {
    myDialog,
    paging,
  },
  data() {
    return {
      diaWidth1: "350px",
      dialogTitle1: "添加外请",
      isShowDialog1: false,
      dialogForm1: {
        employeeName1: "",
      },
      // 地址弹窗
      isShowDialog3: false,
      dialogTitle3: "添加员工",
      diaWidth3: "60%",
      pageStart: 1, //  页码
      pageCount: 0, //  总条数
      pageTotal: this.$COMMON.pageTotals, //  一页几条
      tableData: [],
      addressTableHeard: [
        {
          name: "所属部门",
          field: "deptName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        // {
        //   name: "工号",
        //   field: "number",
        //   width: "120",
        //   sort: 3,
        //   isShow: true, //是否展示
        //   isTotal: false, //是否开启合计
        //   isSort: true, //表格设置里面是否可以排序
        // },
        {
          name: "姓名",
          field: "employeeName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "手机号码",
          field: "phone",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],
      selectTableData: [], // 表格选择
      queryData: {
        // 查询条件
        name: "",
      },
      dialogFormDispatch: {
        objectName: "",
        startAddrType: 1,
        isTractor: 0,
        planDepartureTime: this.$TOOLS.getCurrentDate(),
        driverOnePhone: "",
        driverOneIdcard: "",
        startDeptId: "",
        carTypeConfDictId: "",
        carCategoryConfDictId: "",
        carNumber: "",
        trailerNumber: "",
        driverOneName: "",
        driverTwoName: "",
        driverTwoPhone: "",
        driverTwoIdcard: "",
        supercargoOneName: "",
        supercargoTwoName: "",
        carFollowPersonnelOneName: "",
        carFollowPersonnelTwoName: "",
        totalAmount: "",
        dispatchContractNumber: "",
        remarks: "",
        isAddDriverOne: false,
        isAddDriverTwo: false,
      },

      storageList: [],
      driverList1: [], //司机列表
      driverList2: [], //司机列表
      driverList3: [], //司机列表
      driverList4: [], //司机列表
      car_categoryList: [], //车辆分类
      carNumberList1: [], //车牌号码
      carNumberList2: [], //挂车号码
      car_type_list: [], //车型
      settlementMethodList: [], //付款方式
      objectStatusList: [],
      CustomerListsYF: [], //对象列表
      pageGroupName: "DispatchCar_DeliveryScheduling", //  页面标识
      reportFiledsNumber: "admin_dispatch_send_list", // 动态 条件、表头
      tableData1: [],
      myTableHeard1: [],
      selectTableData1: [], // 表格选择
      employeeList: [],
      employeeList2: [],
      isTractorList: [
        //是否牵引车
        { val: 0, name: "否" },
        { val: 1, name: "是" },
      ],
      startAddrTypeList: [
        { val: 1, name: "仓配送货" },
        { val: 2, name: "提货直送" },
      ],
      totalArr: ["volume", "packageCount", "grossWeight"],
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.getConfDictValDownLists("car_type");
    this.getConfDictValDownLists("car_category");
    this.getConfDictValDownLists("object_status");
    this.getConfDictValDownLists("settlement_method");
    this.getObjectUserDownList("storage");
    this.getcarNumberRmethod("");
  },
  activated() {
    let { ids } = this.$route.query || {};
    this.dialogFormDispatch = {
      // objectName: "",
      // planDepartureTime: this.$TOOLS.getCurrentDate(),
      // startAddrType: 1,
      objectName: "",
      startAddrType: 1,
      isTractor: 0,
      planDepartureTime: this.$TOOLS.getCurrentDate(),
      driverOnePhone: "",
      driverOneIdcard: "",
      startDeptId: "",
      carTypeConfDictId: "",
      carCategoryConfDictId: "",
      carNumber: "",
      trailerNumber: "",
      driverOneName: "",
      driverTwoName: "",
      driverTwoPhone: "",
      driverTwoIdcard: "",
      supercargoOneName: "",
      supercargoTwoName: "",
      carFollowPersonnelOneName: "",
      carFollowPersonnelTwoName: "",
      totalAmount: "",
      dispatchContractNumber: "",
      remarks: "",
      isAddDriverOne: false,
      isAddDriverTwo: false,
    };
    if (ids) {
      this.tableData1 = (ids && JSON.parse(ids)) || [];
      this.initTable();
    }
  },
  destroyed() {},
  methods: {
    // 表格合计
    getSummaries(param) {
      let that = this;
      const { columns, data } = param;

      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index === 1) {
          sums[index] = "";
          return;
        }
        if (this.totalArr.includes(column.property)) {
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return this.$TOOLS.mathToFixed(this.$TOOLS.add(prev, curr), 2);
              } else {
                return prev;
              }
            }, 0);
            sums[index] += "";
          } else {
            sums[index] = "";
          }
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
    runPageReport_down_list_driver(key, e) {
      this.$API
        .runPageReport({
          conditionReqs: [
            {
              conditonKey: "name",
              conditonVal: e,
            },
          ],
          number: "down_list_driver",
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this[key] = res.data.result.datas.data || [];
        });
    },
    // 选择司机/押运
    changeDrivers(e, id, name, listkey, phone, card) {
      this.dialogFormDispatch[id] = "";
      this.dialogFormDispatch[name] = "";
      this.dialogFormDispatch[phone] = "";
      this.dialogFormDispatch[card] = "";
      if (e) {
        this.dialogFormDispatch[name] = e;
        this[listkey].forEach((item) => {
          if (item.name == e) {
            this.dialogFormDispatch[id] = item.id || "";
            if (phone) {
              this.dialogFormDispatch[phone] = item.phone || "";
            }
            if (card) {
              this.dialogFormDispatch[card] = item.idCard || "";
            }
          }
        });
      }
    },
    // 选择随车1
    changeSuiChe(e, id, name) {
      this.dialogFormDispatch[id] = "";
      this.dialogFormDispatch[name] = "";
      if (e) {
        this.dialogFormDispatch[name] = e;
        this.employeeList.forEach((item) => {
          if (item.name == e) {
            this.dialogFormDispatch[id] = item.documentId;
          }
        });
      }
    },

    //员工、部门、外发网点
    focusMethod(key, keys) {
      if (this[keys].length == 0) {
        this.remoteMethod("", key, keys);
      }
    },
    handleSizeChange(val) {
      //  分页
      this.pageTotal = val;
      this.getCustomerAddrList();
    },
    handleCurrentChange(val) {
      //  分页
      this.pageStart = val;
      this.getCustomerAddrList();
    },
    async initTable() {
      let tabelHeadeTitle = [];
      //获取 所有页面 number
      await this.$API
        .getQueryList({
          number: "",
          reportName: "",
        })
        .then((res) => {});
      //获取当前页面已设置表头
      await this.$API
        .getGroupFindFieldSort({
          groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
        })
        .then((res) => {
          let arr = res.data.result || [];
          if (arr.length > 0) {
            if (arr[0].sortObject) {
              tabelHeadeTitle = JSON.parse(arr[0].sortObject);
            }
          }
        });
      if (!tabelHeadeTitle.length) {
        //表格 表头默认
        await this.$API
          .getReportFileds({
            number: this.reportFiledsNumber,
          })
          .then((res) => {
            let datas = res.data.result || [];
            let lists = [];
            datas.forEach((element) => {
              lists.push({
                name: element.fieldNameShow,
                field: element.fieldAlias,
                width: element.wide,
                isTotal: element.isSum,
                sort: element.sort,
                isShow: element.isShow,
                isSort: true,
              });
            });
            tabelHeadeTitle = lists;
          });
      }
      this.myTableHeard1 = tabelHeadeTitle;
    },
    //表格 点击选中当前行
    rowclick1(row, event, column) {
      this.$refs.mytable1.toggleRowSelection(row);
    },
    //表格 表格选择事件
    handleSelectionChange1(e) {
      this.selectTableData1 = e;
    },
    async addform(key) {
      if (key == 1) {
        this.isShowDialog1 = true;
      } else {
        this.getCustomerAddrList();
        this.isShowDialog3 = true;
      }
    },
    handleCloseDia1() {
      this.isShowDialog1 = false;
      this.dialogForm1 = {
        employeeName1: "",
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtn1() {
      this.listShipper.push({
        employeeId: "",
        employeeName: this.dialogForm1.employeeName1,
        employeeType: "wai_qing:employee_type",
      });
      this.isShowDialog1 = false;
    },
    //添加员工
    handleCloseDia3() {
      this.isShowDialog3 = false;
      this.queryData = {
        name: "",
      };
    },
    //添加员工 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },
    //添加员工 表格选择事件
    handleSelectionChange(e) {
      this.selectTableData = e;
    },
    //添加员工  弹窗确认保存事件
    diaConfirmBtn3() {
      if (this.selectTableData.length < 1) {
        this.$message.error("请选择需要的数据");
        return false;
      }
      this.selectTableData.forEach((element) => {
        this.listShipper.push({
          employeeId: element.employeeId,
          employeeName: element.employeeName,
          employeeType: "zi_you:employee_type",
        });
      });
      this.listShipper = this.arrayFilter(this.listShipper, "employeeId");
      this.isShowDialog3 = false;
    },
    arrayFilter(arr, key) {
      return arr.filter((item, index, self) => {
        // 利用findIndex方法找到第一个与当前元素id相等的元素索引
        const i = self.findIndex((t) => t[key] === item[key]);
        // 如果当前索引等于当前元素在self中的最初出现位置索引，则表示元素符合要求，不是重复元素，保留
        return i === index;
      });
    },
    //添加员工
    getCustomerAddrList() {
      this.$API
        .wtl_getEmployeeList({
          employeeName: this.queryData.name,
          pageStart: this.pageStart,
          pageTotal: this.pageTotal,
        })
        .then((res) => {
          this.tableData = res.data.result.data || [];
          this.pageCount = res.data.result.pageCount || 0;
        });
    },

    clickDel(index) {
      this.listShipper.splice(index, 1);
    },
    // 员工、部门、外发网点
    remoteMethod(name, key, keys) {
      // employee 员工
      // dept 部门
      // storage 外发网点
      return this.$API
        .wtl_getObjectUserDownList({
          name,
          key,
          pageStart: 1,
          pageTotal: 20,
        })
        .then((res) => {
          let arrs = res.data.result.data || [];
          this[keys] = arrs;
        });
    },
    // 根据字典类型获取字典值下拉列表
    getConfDictValDownLists(val) {
      this.$COMAPI.getConfDictValDownList(val).then((res) => {
        //车辆分类
        if (val == "car_category") {
          this.car_categoryList = res || [];
        }
        if (val == "car_type") {
          // 车型
          this.car_type_list = res || [];
        }
        if (val == "settlement_method") {
          // 获取付款方式
          this.settlementMethodList = res || [];
        }
        if (val == "object_status") {
          // 获取结算对象类型
          this.objectStatusList = res || [];
        }
      });
    },
    // 选择结算对象类型(
    changeObjestStatusYS(e) {
      console.log("eeee", e);
      this.dialogFormDispatch.objectName = "";
      if (e) {
        this.getObjectUserDownListYf();
        this.objectStatusList.forEach((item) => {
          if (item.key == e) {
            this.dialogFormDispatch.objectStatusConfDictId = item.confDictId;
          }
        });
      } else {
        this.dialogFormDispatch.objectName = "";
        this.dialogFormDispatch.objectNumber = "";
        this.dialogFormDispatch.objectStatusConfDictId = "";
      }
    },
    // (应付弹窗)根据对象类型获取对象的下拉列表
    getObjectUserDownListYf(name) {
      let objectStatusType = this.dialogFormDispatch.objectStatusType;
      this.$API
        .wtl_getObjectUserDownList({
          key: objectStatusType || "",
          name: name || "",
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.CustomerListsYF = res.data.result.data || [];
        });
    },
    changeobjectName(e) {
      if (!e) {
        this.getObjectUserDownListYf();
      } else {
        this.CustomerListsYF.forEach((item) => {
          if (item.name === e) {
            this.dialogFormDispatch.objectNumber = item.number;
          }
        });
      }
    },
    // 获取车辆下拉列表(拿车牌号码)
    changecarCategoryConfDictId(e) {
      if (e) {
        this.$API
          .CarDownList({
            pageStart: 1,
            pageTotal: 200,
            carNumber: "",
            carCategoryConfDictId: e, //车辆分类id
          })
          .then((res) => {
            this.carNumberList1 = res.data.result.data || [];
          });
      }
    },
    // 获取车辆下拉列表(拿挂车号码)
    getcarNumberRmethod(e) {
      this.$API
        .CarArchiveList({
          pageStart: 1,
          pageTotal: 200,
          carNumber: e || "",
        })
        .then((res) => {
          this.carNumberList2 = res.data.result.data || [];
        });
    },
    // 根据对象类型获取对象的下拉列表
    getObjectUserDownList(key, name) {
      this.$COMAPI.getObjectUserDownList(key, name).then((res) => {
        if (key == "storage") {
          //获取网点列表
          this.storageList = res || [];
        }
      }); //获取网点列表
    },

    // 提交
    async submit(saveType) {
      if (this.dialogFormDispatch.startAddrType == 1) {
        if (!this.dialogFormDispatch.startDeptId) {
          this.$message.error("请选择始发网点");
          return false;
        }
      }
      let { driverOneId, isAddDriverTwo, isAddDriverOne } =
        this.dialogFormDispatch;
      this.dialogFormDispatch.saveType = saveType;

      //司机
      // let curs2 = this.driverList.filter(
      //   (item) => item.documentId == driverOneId
      // );
      // this.dialogFormDispatch.driverOneName =
      //   (curs2.length && curs2[0].name) || "";
      this.dialogFormDispatch.orderIds = this.tableData1.map((n, i) => {
        return {
          sort: n.sort,
          waybillDispatchId: n.waybillDispatchId,
        };
      });

      await this.$API
        .sendmoreDispatch({
          ...this.dialogFormDispatch,
          isAddDriverOne: isAddDriverOne ? 1 : 0,
          isAddDriverTwo: isAddDriverTwo ? 1 : 0,
        })
        .then((res) => {
          if (res.data.status === "success") {
            this.$message.success(res.data.message || "操作成功");
            this.$TOOLS.closePage();
            this.$router.push({
              path: "/DispatchCar/OutgoingDispatch",
              query: {
                isreload: "isreload",
              },
            });
          } else {
            this.$message.error(`${res.data.message}---综合查询列表`);
          }
        });
    },
  },
};
</script>
<style scoped lang="less">
// 查询条件边框线
@borderColor: #cccccc;

.topBtns {
  width: calc(100% - 240px);
  position: fixed;
  z-index: 10;
  top: 60px;
  left: 210px;
  background-color: #fff;
  // box-shadow: 2px 2px 5px #ccc;
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
  margin-right: 30px;
  height: 50px;
}
.contentBox {
  padding-bottom: 50px;
}

.infoDiv {
  margin-bottom: 20px;
  .h3title {
    background-color: #f2f2f2;
    padding: 10px;
    border-bottom: 1px solid @borderColor;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .formbox {
    padding: 0 30px;

    .jsInput {
      .jsBtns {
        height: 30px;
        line-height: 30px;
        margin: 0;
        padding: 0 10px;
        border: none;
      }
    }
  }

  .goodsItmes {
    margin-top: 30px;
    border-bottom: 4px solid #ccc;
    padding-bottom: 20px;
  }

  .formBtns {
    height: 30px;
    margin: 0;
    padding: 0 10px;
  }

  .miniInput {
    width: 80px;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
    margin-right: 2px;

    text-align: center;

    /deep/ .el-input__inner {
      text-align: center !important;
      padding: 0 5px;
    }
  }
}

.disFlexs {
  display: flex;
  align-items: center;
  width: 100%;
}

.selectAddress {
  border: 1px solid #ccc;
  margin-right: 10px;
  width: 180px !important;
}
.addressDetails {
  //   width: 380px !important;
  flex: 1;
}

.btmBtns {
  text-align: center;
  margin-top: 50px;

  .saveBtns {
    font-size: 16px;
  }
}

.iconList {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  //   text-align: center;

  .iconSize {
    font-size: 26px;
    cursor: pointer;
  }

  .tbBtns {
    padding: 5px 10px;
    margin: 0;
    border: 1px solid #333;
  }
}

.addTiHuoDiZhi {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin: 20px 0;
}

.multipleSelect {
  display: flex;

  /deep/ .el-select {
    flex: 1;
  }
}

.textArea {
  height: 100%;
}

.glo_btnItems {
  height: 30px;
  line-height: 30px;
  padding: 0 20px;
}

.goodsTable {
  /deep/ .el-table .cell {
    padding-right: 0;
    padding-left: 0;
  }
}

// #tables {
//   .glo_formBox {
//     /deep/ .el-input__icon {
//       line-height: 30px !important;
//     }
//   }
// }
.linkTabel {
  text-align: center;
  cursor: pointer;
}
/deep/ .el-input__icon {
  line-height: 30px !important;
}

.disFlex {
  display: flex;
  align-items: center;
}

.checkBox {
  margin-left: 30px;
}

#tiHuoForm {
  padding: 10px;
  border: 1px dashed @borderColor;
  margin: 0 30px 10px;
}
.textArea {
  height: auto;
}
.setper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 6px;
  border: 1px dashed @borderColor;
  .s_tem {
    margin: 6px;
    .el-icon-error {
      cursor: pointer;
      color: red;
    }
  }
}
</style>
